module.exports = __webpack_public_path__ + "img/ys-8.b1d27ff5.png";